import * as React from "react";
import { DividerProps, SvgIconProps, Typography } from "@mui/material";
import { TitleDivider } from "./TitleDivider";
import { SquareCard, SquareCardProps } from "./SquareCard";
import { TypographyVariant } from "@mui/material/styles/createTypography";

type SquareCardWithContentProps = Omit<SquareCardProps, "title"> & {
  Icon?: React.JSXElementConstructor<SvgIconProps>;
  title?: React.ReactNode;
  titleVariant?: TypographyVariant;
  hideDivider?: boolean;
  titleComponent: React.ElementType;
  slotProps?: {
    divider?: DividerProps
  };
};

function SquareCardWithContent({
  Icon,
  title,
  titleVariant,
  titleComponent,
  hideDivider,
  children,
  slotProps,
  ...props
}: SquareCardWithContentProps) {
  return (
    <SquareCard
      {...props}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        width: "100%",
        ...props.sx,
      }}
    >
      {Icon && (
        <Icon
          sx={{
            width: 100,
            height: 100,
            mb: 2,
          }}
        />
      )}
      {title && (
        <Typography
          variant={titleVariant || "h4"}
          component={titleComponent}
          color="secondary"
        >
          {title}
        </Typography>
      )}
      {title && children && !hideDivider && <TitleDivider sx={{ mt: 3, ...slotProps?.divider?.sx }} />}
      {children}
    </SquareCard>
  );
}

export { SquareCardWithContent };
export type { SquareCardWithContentProps };
